import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import { compose, withPropsOnChange } from 'recompose';
import lazyLoad from "../enhancers/lazyLoad";
import { getRequirementCategoriesAction } from "../../api/jsonapi";
import { getApiObjectList } from "../../util/common";
var enhancer = compose(lazyLoad('requirementCategoriesRequest', getRequirementCategoriesAction, function (perform) {
  return perform({
    include: 'application_stages'
  });
}), getApiObjectList('requirement_categories', 'requirementCategories'), withPropsOnChange(['requirementCategories'], function (_ref) {
  var requirementCategories = _ref.requirementCategories,
    useValue = _ref.useValue;
  var map = {};
  Array.isArray(requirementCategories) && requirementCategories.forEach(function (rc) {
    rc && Array.isArray(rc.application_stages) && rc.application_stages.forEach(function (stage) {
      if (map[stage.label]) {
        map[stage.label].push({
          label: rc.label,
          value: useValue ? rc.value : rc.id
        });
      } else {
        map[stage.label] = [{
          label: rc.label,
          value: useValue ? rc.value : rc.id
        }];
      }
    });
  });
  var options = Object.keys(map).map(function (key) {
    return {
      label: key,
      value: key,
      options: map[key]
    };
  });
  return {
    options: options
  };
}));
export default enhancer;